export default __webpack_public_path__ + "static/media/Wildstrider Bracers.6d22635e.jpg";